import { render } from "./AnnotationInput.vue?vue&type=template&id=4bc538d3&scoped=true"
import script from "./AnnotationInput.vue?vue&type=script&lang=js"
export * from "./AnnotationInput.vue?vue&type=script&lang=js"

import "./AnnotationInput.vue?vue&type=style&index=0&id=4bc538d3&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc538d3"]])

export default __exports__